import { useState, useRef, useEffect } from 'react';
import Modal from './Modal.jsx';
import Button from './Button.jsx';
import FormField from './FormField.jsx';
import { useUpdateBankAccount } from '../hooks/useBankAccounts.js';

export default function BankAccountRenameModal({ account, onClose }) {
  const [name, setName] = useState('');
  const nameRef = useRef(null);
  const update = useUpdateBankAccount();

  const open = !!account;

  useEffect(() => {
    if (open && account) {
      setName(account.name ?? '');
      update.reset?.();
      const t = setTimeout(() => nameRef.current?.focus(), 50);
      return () => clearTimeout(t);
    }
  }, [open, account]); // eslint-disable-line react-hooks/exhaustive-deps

  async function handleSubmit(e) {
    e.preventDefault();
    const trimmed = name.trim();
    if (!trimmed || trimmed === account.name) return;
    try {
      await update.mutateAsync({ id: account.id, name: trimmed });
      onClose();
    } catch {
      // Error displayed via update.error
    }
  }

  if (!account) return null;

  return (
    <Modal
      open={open}
      onClose={onClose}
      title={`Renommer « ${account.name} »`}
    >
      <form onSubmit={handleSubmit} className="space-y-4">
        <FormField label="Nom du compte" htmlFor="barm-name" required>
          <input
            ref={nameRef}
            id="barm-name"
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
            maxLength={100}
            required
            className="block w-full rounded-lg border border-slate-300 px-3 py-2 text-sm focus:outline-none focus:ring-1 focus:ring-slate-500 focus:border-slate-500"
          />
        </FormField>

        {update.error && (
          <div
            className="text-sm text-red-600 bg-red-50 border border-red-200 rounded-lg px-3 py-2"
            role="alert"
          >
            {update.error.message}
          </div>
        )}

        <div className="flex justify-end gap-2">
          <Button type="button" variant="ghost" onClick={onClose} disabled={update.isPending}>
            Annuler
          </Button>
          <Button
            type="submit"
            disabled={!name.trim() || name.trim() === account.name}
            loading={update.isPending}
          >
            Renommer
          </Button>
        </div>
      </form>
    </Modal>
  );
}
